import * as React from "react";
import type { SVGProps } from "react";
const SvgTransforIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="transfor_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M730.112 96.256a41.216 41.216 0 0 0-58.667 2.816 42.283 42.283 0 0 0 2.816 59.307l72.747 66.858H321.749a200.533 200.533 0 0 0-135.594 51.883C149.46 310.827 128 357.504 128 407.083v69.973c0 23.168 18.603 41.941 41.515 41.941s41.514-18.773 41.514-41.941V407.04c0-24.619 10.582-49.11 30.976-67.84a118.059 118.059 0 0 1 79.744-30.08h425.259l-72.747 66.859a42.283 42.283 0 0 0-2.816 59.306 41.216 41.216 0 0 0 58.667 2.816L880.64 299.733c9.387-7.68 15.36-19.413 15.36-32.597a42.07 42.07 0 0 0-15.232-32.427L730.112 96.213zM896 546.986a41.728 41.728 0 0 0-41.515-41.983 41.728 41.728 0 0 0-41.514 41.984v69.93c0 24.619-10.582 49.11-30.976 67.84a118.059 118.059 0 0 1-79.744 30.08H276.907l72.789-66.858a42.283 42.283 0 0 0 2.773-59.307 41.216 41.216 0 0 0-58.624-2.816L141.568 725.76A42.027 42.027 0 0 0 128 756.139v.682a42.08 42.08 0 0 0 14.08 31.488l151.723 139.435a41.216 41.216 0 0 0 58.624-2.816 42.283 42.283 0 0 0-2.774-59.307l-72.746-66.858h425.386a200.533 200.533 0 0 0 135.552-51.883C874.54 713.173 896 666.496 896 616.917v-69.973z"
    />
  </svg>
);
export default SvgTransforIcon;
